module.exports = __webpack_public_path__ + "img/HC2024-01.dd99f648.jpg";